(function () {
  if (window.__giftingPopupInit) return;
  window.__giftingPopupInit = true;

  function getSydneyTime() {
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'Australia/Sydney' }));
  }

  function getDeliveryCfg() {
    try {
      var el = document.getElementById('GiftingOptionsData');
      return (el ? JSON.parse(el.textContent) : {}).delivery || {};
    } catch (e) { return {}; }
  }

  function isSundayException(date, cfg) {
    if (!cfg.sunday_exception_enabled || !cfg.sunday_exception_date) return false;
    var ex = new Date(cfg.sunday_exception_date + 'T00:00:00');
    return date.getFullYear() === ex.getFullYear() &&
      date.getMonth() === ex.getMonth() &&
      date.getDate() === ex.getDate();
  }

  function disableSundays(date) {
    var cfg = getDeliveryCfg();
    return date.getDay() === 0 && !isSundayException(date, cfg);
  }

  function getMinDeliveryDate() {
    var cfg = getDeliveryCfg();
    var cutoffHour = cfg.cutoff_hour !== undefined ? cfg.cutoff_hour : 19;
    var cutoffMinute = cfg.cutoff_minute !== undefined ? cfg.cutoff_minute : 0;

    var now = getSydneyTime();
    var cutoff = getSydneyTime();
    cutoff.setHours(cutoffHour, cutoffMinute, 0, 0);

    var minDate = getSydneyTime();
    if (now >= cutoff) {
      minDate.setDate(minDate.getDate() + 2);
    } else {
      minDate.setDate(minDate.getDate() + 1);
    }
    return minDate;
  }

  function detectBundleSize(form) {
    var bundleSize = 0;
    var fieldsets = form.querySelectorAll('variant-selects fieldset, variant-radios fieldset');
    for (var i = 0; i < fieldsets.length; i++) {
      var label = fieldsets[i].querySelector('legend, label');
      var optionName = label ? (label.textContent || '').trim().toLowerCase() : '';
      if (optionName === 'bundle size' || optionName === 'size' || optionName === 'frequency') {
        var select = fieldsets[i].querySelector('select[name^="options"]');
        var radio = fieldsets[i].querySelector('input[type="radio"]:checked');
        var value = (select ? select.value : (radio ? radio.value : '')).toLowerCase();
        if (value.indexOf('10') !== -1) { bundleSize = 10; break; }
        if (value.indexOf('8') !== -1) { bundleSize = 8; break; }
        if (value.indexOf('5') !== -1) { bundleSize = 5; break; }
      }
    }
    return bundleSize;
  }

  function initPopup(wrapper) {
    if (wrapper.dataset.giftingPopupInit) return;
    wrapper.dataset.giftingPopupInit = 'true';

    var formId = wrapper.dataset.formId;
    var form = document.getElementById(formId);
    if (!form) return;

    var submitButton = form.querySelector('[type="submit"]');
    var modal = document.getElementById(wrapper.dataset.modalId);
    if (!submitButton || !modal) return;

    var configScript = document.getElementById('GiftingOptionsData');
    if (configScript) {
      try {
        var config = JSON.parse(configScript.textContent);

        var occasionSelect = wrapper.querySelector('[data-bundle-config-target="occasions"]');
        if (occasionSelect && config.occasions && config.occasions.length > 0) {
          var defaultOccasionOption = occasionSelect.options[0];
          occasionSelect.innerHTML = '';
          occasionSelect.appendChild(defaultOccasionOption);
          config.occasions.forEach(function (occ) {
            var opt = document.createElement('option');
            opt.value = occ.value;
            opt.textContent = occ.label;
            occasionSelect.appendChild(opt);
          });
        }

        var messageSelect = wrapper.querySelector('[data-bundle-config-target="messages"]');
        if (messageSelect && config.messages && config.messages.length > 0) {
          var defaultMessageOption = messageSelect.querySelector('[data-config-default-target]');
          messageSelect.innerHTML = '';
          if (defaultMessageOption) messageSelect.appendChild(defaultMessageOption);

          var categories = [];
          config.messages.forEach(function (m) {
            var cat = m.category || 'General';
            if (categories.indexOf(cat) === -1) categories.push(cat);
          });
          categories.forEach(function (cat) {
            var group = document.createElement('optgroup');
            group.label = cat;
            config.messages.filter(function (m) { return (m.category || 'General') === cat; }).forEach(function (msg) {
              var opt = document.createElement('option');
              opt.value = msg.message;
              opt.textContent = msg.label;
              group.appendChild(opt);
            });
            messageSelect.appendChild(group);
          });
        }

        if (config.settings) {
          var labelEl = wrapper.querySelector('[data-config-label-target]');
          if (labelEl && config.settings.card_message_label) labelEl.textContent = config.settings.card_message_label;

          var defaultOpt = wrapper.querySelector('[data-config-default-target]');
          if (defaultOpt && config.settings.message_template_default) defaultOpt.textContent = config.settings.message_template_default;

          var textEl = wrapper.querySelector('[data-config-placeholder-target]');
          if (textEl && config.settings.card_message_placeholder) textEl.placeholder = config.settings.card_message_placeholder;
        }
      } catch (e) {
        console.error('Error parsing GiftingOptionsData:', e);
      }
    }

    var cardMessageEl = wrapper.querySelector('[name="properties[Card Message]"]');
    var charCountEl = wrapper.querySelector('.char-count');
    if (cardMessageEl && charCountEl) {
      cardMessageEl.addEventListener('input', function () {
        var length = cardMessageEl.value.length;
        charCountEl.textContent = length + ' / 250';
        charCountEl.style.color = length >= 250 ? 'rgb(var(--color-error))' : 'rgba(var(--color-foreground), 0.5)';
      });
    }

    var templateSelectEl = wrapper.querySelector('.message-template-select');
    if (templateSelectEl && cardMessageEl) {
      templateSelectEl.addEventListener('change', function () {
        if (templateSelectEl.value) {
          cardMessageEl.value = templateSelectEl.value;
          cardMessageEl.dispatchEvent(new Event('input'));
        }
      });
    }

    var confirmed = false;

    var dateInput = wrapper.querySelector('.gifting-popup-date-input');
    if (dateInput && typeof flatpickr !== 'undefined') {
      flatpickr(dateInput, {
        dateFormat: 'Y-m-d',
        altInput: true,
        altFormat: 'd/m/Y',
        minDate: getMinDeliveryDate(),
        disable: [disableSundays]
      });
    }


    var giftToggles = wrapper.querySelectorAll('[data-gifting-toggle]');
    var giftFields = wrapper.querySelector('[data-gifting-fields]');
    function isGiftSelected() {
      var checked = wrapper.querySelector('[data-gifting-toggle]:checked');
      return checked ? checked.value === 'true' : true;
    }
    function updateGiftFieldsVisibility() {
      if (!giftFields) return;
      giftFields.hidden = !isGiftSelected();
    }
    giftToggles.forEach(function (radio) {
      radio.addEventListener('change', updateGiftFieldsVisibility);
    });
    updateGiftFieldsVisibility();

    function isActive() {
      return detectBundleSize(form) === 0;
    }

    function openModal() {
      modal.style.display = 'block';
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.style.display = 'none';
      document.body.style.overflow = '';
    }

    var closeBtn = modal.querySelector('[data-gifting-popup-close]');
    if (closeBtn) closeBtn.addEventListener('click', closeModal);

    form.addEventListener('submit', function (evt) {
      if (!isActive()) return;
      if (confirmed) {
        confirmed = false;
        return;
      }
      evt.preventDefault();
      evt.stopImmediatePropagation();
      openModal();
    }, true);

    var confirmBtn = wrapper.querySelector('[data-gifting-popup-confirm]');
    if (confirmBtn) {
      confirmBtn.addEventListener('click', function () {
        var errors = [];

        if (!dateInput || !dateInput.value || !dateInput.value.trim()) {
          errors.push('Please choose a delivery date.');
        }
        if (isGiftSelected()) {
          var recipientName = wrapper.querySelector('[name="properties[Recipient Name]"]');
          if (!recipientName || !recipientName.value.trim()) errors.push('Recipient name is required when this is a gift.');
        }

        var errorEl = wrapper.querySelector('[data-gifting-popup-error]');
        if (errors.length > 0) {
          if (errorEl) {
            errorEl.textContent = errors.join(' ');
            errorEl.hidden = false;
          }
          return;
        }
        if (errorEl) errorEl.hidden = true;

        confirmed = true;
        closeModal();
        submitButton.click();
      });
    }
  }

  function runInit() {
    document.querySelectorAll('[data-gifting-popup-wrapper]').forEach(initPopup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runInit);
  } else {
    runInit();
  }
})();